import { ProgressBarComponent, Text } from '../../../Components'
import { cap } from '../../../State'
import { translations } from '../../../translations'

const language = cap.language.state || 'IT'
const t = translations[language]

const getStatusColor = (value, max) => {
  if (!max) return 'var(--success)'
  const ratio = value / max
  if (ratio < 0.3) return 'var(--success)'
  if (ratio < 0.6) return 'var(--warning)'
  if (ratio < 0.8) return 'var(--warning)'
  return 'var(--danger)'
}

/**
 * Pannello con lo stato del server: modelli AI, token, richieste, coda e canali.
 * @param {{ gianpietroStats: Array, channels: Array }} props
 * @returns {JSX.Element}
 */
export const ServerStatusPanel = ({ gianpietroStats = [], channels = [] }) => {
  const authenticated =
    channels.find(({ channel }) => channel === 'authenticated')?.connections?.length || 0

  const channelRows = channels.filter(({ channel }) => channel !== 'authenticated')

  return (
    <div className="ncard">
      <div className="ncard__head">
        <div className="ncard__ico">
          <i className="pi pi-server" style={{ fontSize: 16 }} />
        </div>
        <div>
          <h3 className="ncard__title">{t.pfServerCanali}</h3>
          <div className="ncard__sub">
            {t.pfStatoInTempoReale}
            {authenticated > 0 ? ` · ${authenticated} ${t.pfOperatori}` : ''}
          </div>
        </div>
      </div>
      <div
        className="ncard__body"
        style={{ padding: 0, maxHeight: 'min(60vh, 460px)', overflowY: 'auto' }}
      >
        {channelRows.map((c, i) => {
          const name = c.channel || c.name || t.pfCanale
          const ok = c.ok !== false && !c.error
          const msg =
            c.msg ||
            c.status ||
            (c.connections?.length != null ? `${c.connections.length}${t.pfConnSuffix}` : '')
          return (
            <div
              key={name}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '12px 22px',
                borderTop: i === 0 ? 'none' : '1px solid var(--border)'
              }}
            >
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  background: ok ? 'var(--success)' : 'var(--danger)',
                  animation: 'nora-pulse 1.8s infinite',
                  flexShrink: 0
                }}
              />
              <span
                style={{
                  fontFamily: 'var(--font-mono)',
                  fontSize: 12.5,
                  color: 'var(--ink-900)',
                  flex: 1
                }}
              >
                {name}
              </span>
              <span style={{ fontSize: 12, color: ok ? 'var(--ink-500)' : 'var(--danger)' }}>
                {msg}
              </span>
            </div>
          )
        })}
        {gianpietroStats.map(
          (
            {
              lastMinuteTokens,
              lastMinuteRequests,
              inQueueRequests,
              maxTokensPerMinute,
              maxExecutionsPerMinute,
              model
            },
            i
          ) => (
            <div
              key={model || i}
              style={{
                padding: '14px 22px',
                borderTop: '1px solid var(--border)'
              }}
            >
              <Text bold value={model} size={13} style={{ marginBottom: 8 }} />
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <div>
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}
                  >
                    <Text value={t.pfTokenMin} size={11} style={{ color: 'var(--ink-500)' }} />
                    <Text bold value={`${lastMinuteTokens} / ${maxTokensPerMinute}`} size={11} />
                  </div>
                  <ProgressBarComponent
                    value={lastMinuteTokens}
                    total={maxTokensPerMinute}
                    color={getStatusColor(lastMinuteTokens, maxTokensPerMinute)}
                  />
                </div>
                <div>
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}
                  >
                    <Text value={t.pfRichiesteMin} size={11} style={{ color: 'var(--ink-500)' }} />
                    <Text
                      bold
                      value={`${lastMinuteRequests} / ${maxExecutionsPerMinute}`}
                      size={11}
                    />
                  </div>
                  <ProgressBarComponent
                    value={lastMinuteRequests}
                    total={maxExecutionsPerMinute}
                    color={getStatusColor(lastMinuteRequests, maxExecutionsPerMinute)}
                  />
                </div>
                <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                  <Text value={t.pfInCoda} size={11} style={{ color: 'var(--ink-500)' }} />
                  <Text
                    bold
                    value={inQueueRequests}
                    size={11}
                    style={inQueueRequests > 0 ? { color: 'var(--warning)' } : undefined}
                  />
                </div>
              </div>
            </div>
          )
        )}
        {!gianpietroStats.length && !channelRows.length && (
          <div style={{ padding: '22px', color: 'var(--ink-500)', fontSize: 13 }}>
            {t.pfNessunDatoServer}
          </div>
        )}
      </div>
    </div>
  )
}
